export default __webpack_public_path__ + "static/media/solana.5c4408b9.svg";